import { ExternalLink } from "lucide-react";
import linqLogo from "@/assets/linq-logo.png";

const DigitalBusinessCard = () => {
  return (
    <div className="relative text-center py-8 px-6 bg-[#1a1a1a] border border-[#d4af37] rounded-lg shadow-lg animate-pulsating-glow">
      <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
        {/* Linq Logo with rotating blue glow */}
        <div className="flex-shrink-0">
          <img 
            src={linqLogo} 
            alt="Linq Digital Business Card" 
            className="w-16 h-16 md:w-20 md:h-20 rounded-md shadow-md animate-linq-glow"
            loading="lazy"
            width="80"
            height="80"
            decoding="async"
          />
        </div>
        
        {/* Content */}
        <div className="flex-1 text-center md:text-left">
          <p className="text-white font-serif text-lg mb-3">
            Connect with Rick Ruiz-Estrada
          </p>
          <a
            href="https://linqapp.com/rick_n_ruizestrada?r=link"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#d4af37] text-[#1a1a1a] font-semibold rounded-md transition-all duration-300 hover:bg-[#c49d2f] hover:shadow-lg hover:scale-105"
          >
            View My Digital Business Card
            <ExternalLink className="w-4 h-4" />
          </a>
          <p className="text-[#cccccc] text-sm mt-3">
            Save my contact, book a ride, or learn more with one click.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DigitalBusinessCard;
